var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNodeHeader = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "SVG_NodeHeader",
  x: "0px",
  y: "0px",
  viewBox: "0 0 65 65",
  style: {
    enableBackground: "new 0 0 65 65"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0SVG_NodeHeader{fill:none;stroke:#071F33;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1SVG_NodeHeader{fill:#071F33;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0SVG_NodeHeader",
  d: "M65,19H37.9c0,0-5.4,0-5.4,6s0,40,0,40"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0SVG_NodeHeader",
  d: "M65,32.6H45.6c0,0-3.8,0-3.8,4.2s0,28.2,0,28.2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0SVG_NodeHeader",
  d: "M65,45.9H50.8c0,0-2.8,0-2.8,2.5c0,1.2,0,4.9,0,8.5c0,4.1,0,8.1,0,8.1"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1SVG_NodeHeader",
  d: "M29.2,65V31.7c0,0,3.1-3.1,6.7,0V65H29.2z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNodeHeader, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NodeHeader.60416699.svg";
export { ForwardRef as ReactComponent };